import { computed, reactive } from 'vue';
import type { MapLayer } from '../models';
import { useMap } from './map.composable';

export const useMapLayer = (layer: MapLayer) => {
  const reactiveLayer = reactive(layer);

  const enabled = computed({ get: () => reactiveLayer.enabled, set: (val) => (reactiveLayer.enabled = val) });

  const loading = computed({ get: () => reactiveLayer.loading, set: (val) => (reactiveLayer.loading = val) });

  const opacity = computed({ get: () => reactiveLayer.opacity, set: (val) => (reactiveLayer.opacity = val) });

  const extent = computed(() => reactiveLayer.extent);

  const fitIntoView = () => {
    if (!reactiveLayer.group?.map) return;

    const composedMap = useMap(reactiveLayer.group.map);
    composedMap.fitExtentInView(extent.value);
  };

  return {
    reactiveLayer,
    enabled,
    loading,
    opacity,
    extent,
    fitIntoView
  };
};
